import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import get from "lodash/get";
import { SendToNewsEmbed } from "./SendToNewsEmbed";
import { ErrorBoundary } from "../error-boundary";
import { useStoryVideoSlot, claimHostRender } from "./storyVideoOrchestrator";
import "../Widget/widget.module.css";
import "./video-player.m.css";

export const StoryVideoWidget = ({ videoAdCode, id }) => {
  const removeThirdPartyScripts = useSelector((state) =>
    get(state, ["qt", "removeThirdPartyScripts"], false)
  );
  const slotRef = useRef(null);

  // Stably claim rendering of the persistent player host once on mount/hydration
  const [isPrimaryHost] = useState(() => claimHostRender());

  useStoryVideoSlot(slotRef);

  if (removeThirdPartyScripts) return null;

  return (
    <ErrorBoundary>
      <div
        data-test-id="widget"
        styleName="widgetWrapper"
        className="story-video-widget"
        id={id ? `${id}-container` : undefined}
        ref={slotRef}
        data-story-video-slot="true"
      >
        {isPrimaryHost && (
          <div
            id="stn-story-player-host"
            className="stn-story-player-host"
            style={{ width: "100%", height: "100%" }}
          >
            <SendToNewsEmbed videoAdCode={videoAdCode} />
          </div>
        )}
      </div>
    </ErrorBoundary>
  );
};

StoryVideoWidget.propTypes = {
  videoAdCode: PropTypes.string,
  id: PropTypes.string,
};

export default StoryVideoWidget;
